import React, { useState, useEffect, useRef } from "react";
import { Steps, Spin } from "antd";
import PropTypes from "prop-types";
import { getRequest } from "../../axios";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";

const DemoStatus = ({ id, setDotLoaded }) => {
  const [status, setStatus] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef(null);

  //   useEffect(() => {
  //     const getPurchaseRequisitionList = async () => {
  //       setLoading(true);
  //       try {
  //         let apiResponse = await getRequest(
  //           `pr-rfq-stage/?company_id=${CompanyID}&pr_id=${prID}`
  //         );

  //         if (apiResponse.data.results.success) {
  //           const fetchedData = apiResponse.data.results.data[0].stage_response;
  //           setRes(fetchedData);
  //           setDotLoaded(true);

  //           // Find last finished index
  //           const lastFinishedIndex = fetchedData
  //             .map((item) => item.title)
  //             .lastIndexOf("Finished");

  //             setTimeout(() => {
  //               if (scrollContainerRef.current) {
  //                 const stepElements =
  //                   scrollContainerRef.current.querySelectorAll(".ant-steps-item");
  //                 if (stepElements[lastFinishedIndex]) {
  //                   stepElements[lastFinishedIndex].scrollIntoView({
  //                     behavior: "smooth",
  //                     block: "start",
  //                   });
  //                 }
  //               }
  //             }, 200);

  //           setCurrentStep(lastFinishedIndex !== -1 ? lastFinishedIndex : -1);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching PR status:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     getPurchaseRequisitionList();
  //   }, [prID]);

  useEffect(() => {
    const getPurchaseRequisitionList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(
          `request-demo-stage/?request_demo_id=${id}`
        );
        if (apiResponse.data.results.success) {
          const fetchedData = apiResponse.data.results.data[0].stage_response;
          
          setRes(fetchedData);
          setDotLoaded(true);



          // Find last finished index
          const lastFinishedIndex = fetchedData
            .map((item) => item.title)
            .lastIndexOf("Finished");

            console.log('fetchedData', fetchedData, lastFinishedIndex);
            

          setTimeout(() => {
            if (scrollContainerRef.current) {
              const stepElements =
                scrollContainerRef.current.querySelectorAll(".ant-steps-item");
              if (stepElements[lastFinishedIndex]) {
                stepElements[lastFinishedIndex].scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            }
          }, 200);

          setCurrentStep(lastFinishedIndex !== -1 ? lastFinishedIndex : -1);
        }
      } catch (error) {
        console.error("Error fetching PR status:", error);
      } finally {
        setLoading(false);
      }
    };

    getPurchaseRequisitionList();
  }, []);

  return (
    <div
      ref={scrollContainerRef}
      className="gridtimelinepopup"
      style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <Spin size="medium" />
        </div>
      ) : (
        <Steps
          size="large"
          progressDot
          current={currentStep}
          direction="vertical"
          items={res?.map((item, index) => {
            const attachmentField = `${item.key.toLowerCase()}_attachemnt`;
            const downloadUrl = item[attachmentField];

            return {
              title: (
                <span
                  style={{
                    fontWeight: index === currentStep + 1 ? "650" : "normal",
                    fontSize: index === currentStep + 1 ? "16px" : "14px",
                    color: index === currentStep + 1 ? "#555555" : "inherit",
                  }}
                >
                  {item.title} {item.updated_at && (
                    <span>
                      | {moment(item.updated_at).format("DD-MM-YYYY HH:mm")}
                    </span>
                  )}
                </span>
              ),
              description: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: index === currentStep + 1 ? "650" : "normal",
                    fontSize: index === currentStep + 1 ? "16px" : "14px",
                    color: index === currentStep + 1 ? "#555555" : "inherit",
                  }}
                >
                  <span>{item.description}</span>
                  
                  
                  {downloadUrl && (
                    <a
                      href={downloadUrl}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Download Document"
                    >
                      <DownloadOutlined
                        style={{ fontSize: 16, color: "#1890ff" }}
                      />
                    </a>
                  )}
                </div>
              ),
            };
          })}
        />
      )}
    </div>
  );
};

DemoStatus.propTypes = {
  id: PropTypes.number,
  setDotLoaded: PropTypes.func,
};

export default React.memo(DemoStatus);
